import {email, phoneNumber, required, url} from '../../../../_utils/validators';

const contactValidator = (value, type) => {
  let error = required(value);
  if (!error) {
    if (type === 'email') error = email(value);
    if (type === 'phone') error = phoneNumber(value);
    if (type === 'website') error = url(value);
  }
  return error ? error : undefined;
};

export default contactValidator;